export default __webpack_public_path__ + "static/media/references__cafe.564c772c.jpg";